import React from 'react';
import * as css from './TimeRowShell.css';

interface TimeRowShellProps {
    time: string;
    children: React.ReactNode;
}

function TimeRowShell({time, children}: TimeRowShellProps) {
    return (
        <css.row>
            <css.timeLabel>{time}</css.timeLabel>
            {children}
        </css.row>
    );
}

export default TimeRowShell;
